import React from 'react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';
import i18n from '../../i18n';
import { CustomTitle } from '../helpers/customTitle';
import { ActiveAuctions } from './auctionsCategory/active';
//import { HotMarketAuctions } from "./helpers/hotMarketAuction";
import { getAuctionChartData, getTodayEndAuctions } from '../../models/auctions';
import { TodayEndingAuctions } from './auctionsCategory/today';
import { SkeletonHomeCard } from '../helpers/skeletons/skeletonCards';

export class TodayAuctions extends React.Component {
    constructor() {
        super();
        this.state = {
            firstload: true,
            secondLoad: false,
            lightboxImages: [],
            is_active_light_box: false,
            count: 0,
            is_loading_1: false,
            hasData: true,
            limit: 10,
            auctions: [],
            is_loading: false,

        };
        this.getImagePopup = this.getImagePopup.bind(this);
    }

    getImagePopup(active, images) {
        let lightboxImages = [];
        if (images) {
            images.forEach(function (arrayItem) {
                lightboxImages.push({
                    url: arrayItem.image,
                });
            });
        }
        this.setState({
            is_active_light_box: active,
            lightboxImages: lightboxImages,
        });
    }

    componentDidMount() {
        this.loadAllAuctions(this.state.limit);
    }

    async loadAllAuctions(limit) {
        let q = limit ? "limit=" + limit : "";
        this.setState({ is_loading: true });
        const response = await getTodayEndAuctions(q);

        if (response) {
            let auctions = response.data;
            let meta = response.meta;

            this.setState({ auctions, meta, is_loading: false });

            if (this.props.getCount) {
                this.props.getCount(auctions.length);
            }
        }
    }

    sortByOrder(data) {
        let result = data;
        if (data.length) {
            result = data.sort((a, b) => a.order - b.order);
        }
        return result;
    }

    render() {
        if (!this.state.hasData) return null;

        // if still loading, show skeletons
        if (this.state.is_loading) {
            return (
                <div style={{ textAlign: "center" }}>
                    <SkeletonHomeCard />
                </div>
            );
        }

        // hide section if no auctions
        if (!this.state.auctions || this.state.auctions.length === 0) {
            return null;   // ✅ don't render anything
        }

        return (
            <React.Fragment>
                <section className="mt-2 mb-2 overflow-hidden">
                    <div className="container-fluid p-0">
                        <div className="section-title center-block text-center">
                            <CustomTitle
                                title={i18n.t('ending_soon')}
                                icon="ri_auction-fill.png"
                                icon_type="img"
                                count={this.state.auctions.length}
                                need_mzad_icon={true}
                            />
                        </div>

                        <div className="col-md-12">
                            <div className="items-gallery">
                                <div className="items-blog-tab text-center">
                                    <div className="tab-content auc-card-wrapper">
                                        <div className="tab-pane active">
                                            <TodayEndingAuctions
                                                auctions={this.sortByOrder(this.state.auctions)}
                                                is_loading={this.state.is_loading}
                                                getImagePopup={this.getImagePopup}
                                                getCount={(count) => this.setState({ count })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {this.state.is_active_light_box && (
                    <Lightbox
                        images={this.state.lightboxImages}
                        onClose={() => {
                            this.setState({ is_active_light_box: false });
                        }}
                    />
                )}
            </React.Fragment>
        );
    }

}
